<p>
  mapfre-dropdown works!
</p>
